import { pathOr } from 'ramda';
import { createSelector } from 'reselect';

import { selectors } from '@ezugi/bootstrap';

const { localeSelector } = selectors;

export const totalLabelSelector = createSelector(
  localeSelector,
  pathOr('TOTAL', [ 'general', 'total' ])
);
